import React, { useEffect, useState } from "react";
import { FaHandPointUp } from "react-icons/fa";

import "./Top.scss";

function Top() {
  const [visible, setVisible] = useState(false);

  const scrollFunction = () => {
    if (window.pageYOffset > 20) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  const topEvent = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", scrollFunction);
    return () => window.removeEventListener("scroll", scrollFunction);
  }, []);

  return (
    <button
      id="topButton"
      onClick={topEvent}
      style={{ visibility: visible ? "visible" : "hidden" }}
      title="Go to top"
      className="bg-[#313bac] hover:drop-shadow-blueShadow dark:bg-[#007991] dark:hover:drop-shadow-cyanShadow"
    >
      <FaHandPointUp area-hidden="true" />
    </button>
  );
}

export default Top;
